module.exports = __webpack_public_path__ + "static/media/firstPage.b2593a98.svg";